var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuesaxOutlineDiagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_diagram",
    "data-name": "vuesax/outline/diagram",
    transform: "translate(-300 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.75,21.5h-17A3.751,3.751,0,0,1,0,17.75V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v17A2.253,2.253,0,0,0,3.75,20h17a.75.75,0,0,1,0,1.5Z",
    transform: "translate(301.25 253.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.75,11.5a.75.75,0,0,1-.57-1.24L4.77,4.9a2.767,2.767,0,0,1,1.98-.96,2.8,2.8,0,0,1,2.05.8l.95.95a1.291,1.291,0,0,0,.93.37,1.222,1.222,0,0,0,.9-.44L16.17.26a.752.752,0,1,1,1.14.98L12.72,6.6a2.767,2.767,0,0,1-1.98.96,2.8,2.8,0,0,1-2.05-.8l-.94-.95a1.251,1.251,0,0,0-.93-.37,1.222,1.222,0,0,0-.9.44L1.33,11.24A.8.8,0,0,1,.75,11.5Z",
    transform: "translate(304.25 258.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(300 252)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDiagram);
export default __webpack_public_path__ + "static/media/vuesax-outline-diagram.1bf7c1cf1dad6ca7b80d05282bd50508.svg";
export { ForwardRef as ReactComponent };